import { Trascodifica } from ".";
import { DocumentiRichiestaMutuoUploader } from './documenti-richiesta-mutuo-uploader';
import { RichiestaMutuoRichiedente } from './richiesta-mutuo-richiedente';

export class DocumentiRichiestaMutuoRichiedenteUploader {

  richiedente: RichiestaMutuoRichiedente;
  mapFileUploader: Map<String, Array<DocumentiRichiestaMutuoUploader>>;
  posizioneLavorativa: Trascodifica;

  constructor(richiedente: RichiestaMutuoRichiedente, mapFileUploader: Map<String, Array<DocumentiRichiestaMutuoUploader>>) {
    this.richiedente = richiedente;
    this.mapFileUploader = mapFileUploader;
  }

  getDocUploader(): Array<DocumentiRichiestaMutuoUploader> {
    if (this.richiedente.posizioneLavorativa !== undefined) {
      if (this.checkPosizione('Dipendente', 'Pensionato')) {
        return this.mapFileUploader.get('dipendente');
      } else if (this.checkPosizione('Autonomo', 'Professionista')) {
        return this.mapFileUploader.get('autonomo');
      } else {
        return this.mapFileUploader.get('altro');
      }
    }
    return undefined;
  }

  removeDocUploader(index: number, indexDoc: number) {
    if (this.richiedente.posizioneLavorativa !== undefined) {
      if (this.checkPosizione('Dipendente', 'Pensionato')) {
        this.mapFileUploader.get('dipendente')[index].documenti.splice(indexDoc, 1);
        this.mapFileUploader.get('dipendente')[index].uploader.options.queueLimit = 
              this.mapFileUploader.get('dipendente')[index].uploader.options.queueLimit + 1;
      } else if (this.checkPosizione('Autonomo', 'Professionista')) {
        this.mapFileUploader.get('autonomo')[index].documenti.splice(indexDoc, 1);
        this.mapFileUploader.get('autonomo')[index].uploader.options.queueLimit = 
              this.mapFileUploader.get('autonomo')[index].uploader.options.queueLimit + 1;
      } else {
        this.mapFileUploader.get('altro')[index].documenti.splice(indexDoc, 1);
        this.mapFileUploader.get('altro')[index].uploader.options.queueLimit = 
              this.mapFileUploader.get('altro')[index].uploader.options.queueLimit + 1;
      }
    }
  }

  removeDocUploaderGeneral(index: number, indexDoc: number) {
    this.mapFileUploader.get('generale')[index].documenti.splice(indexDoc, 1);
    this.mapFileUploader.get('generale')[index].uploader.options.queueLimit = 
              this.mapFileUploader.get('generale')[index].uploader.options.queueLimit + 1;
      
  }

  private checkPosizione(...posizioni: string[]): boolean {
    return this.richiedente && 
      this.richiedente.posizioneLavorativa && 
      posizioni.findIndex(p=>this.richiedente.posizioneLavorativa.descrizione.startsWith(p)) >= 0
  }

}



// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/models/documenti-richiesta-mutuo-richiedente-uploader.ts